import AccountRoutes from './AccountRoutes.js';
import BaseRoutes from './BaseRoutes.js';
import CarrierRoutes from './CarrierRoutes.js';
import CashflowRoutes from './CashflowRoutes.js';
import DashboardRoutes from './DashboardRoutes.js';
import LeadRoutes from './LeadRoutes.js';
import MapRoutes from './MapRoutes.js';
import QuotesRoutes from './QuotesRoutes.js';
import ReportRoutes from './ReportRoutes.js';
import SetupRoutes from './SetupRoutes.js';
import UserRoutes from './AgentRoutes.js';

export default [].concat(
	AccountRoutes,
	BaseRoutes,
	CarrierRoutes,
	CashflowRoutes,
	DashboardRoutes,
	LeadRoutes,
	MapRoutes,
	QuotesRoutes,
	ReportRoutes,
	SetupRoutes,
	UserRoutes
);



// WEBPACK FOOTER //
// ./src/router/routes.js